module.exports = require("./vai-Vaii.d.ts");